import React from 'react';
import PropTypes from 'prop-types';
import Footer from 'components/Footer/Footer';
import './app.scss';

const App = ({ ...props }) => (
  <div className="app">
    <div className="app__inner">
      { props.children }
    </div>
    <Footer />
  </div>
);

App.propTypes = {
  children: PropTypes.element,
};

App.defaultProps = {
  children: null,
};

export default App;



// WEBPACK FOOTER //
// ./layouts/App/App.js